import React from 'react';
import { observer } from 'mobx-react';
import { TeamsListTemplate } from 'themes/application/teams/pages';
import { setCurrentView } from 'core/utils';
import { TeamsViewStore } from 'application/teams/stores';

@setCurrentView((rootStore) => new TeamsViewStore(rootStore), 'teamsListViewStore')
@observer
class TeamsList extends React.Component {
    render() {
        return <TeamsListTemplate {...this.props} />
    }
}

export default TeamsList;